import { createQueryKeys } from '@lukemorales/query-key-factory';

import { get } from '@/api/api';
import type { FanguardApiContractsTicketTypesResponseModel } from 'src/api/generated';

export const TICKET_TYPES_URI = 'tickettypes';

export const ticketTypesQueries = createQueryKeys(TICKET_TYPES_URI, {
  all: null,
  list: {
    queryKey: ['list'] as const,
    queryFn: async () => {
      const response = await get<FanguardApiContractsTicketTypesResponseModel[]>({ uri: TICKET_TYPES_URI });
      return response.data;
    },
  },
  detail: (id: string) => ({
    queryKey: [id],
    queryFn: async () => {
      const response = await get<FanguardApiContractsTicketTypesResponseModel>({
        uri: `${TICKET_TYPES_URI}/${id}`,
      });
      return response.data;
    },
  }),
});
